import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Flex } from '@rebass/grid';
import Text from '../../atoms/Text';
import Button from '../../atoms/Button';

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 22px;
`;

const SuccessPage = ({ appType, ...props }) => {
  const location = appType === 'kolour_tw' ? '荃灣千色匯' : '元朗千色匯';
  const redeemAddress = appType === 'kolour_tw' ? 'I 期地下大門(電訊數碼旁)' : '地下禮賓部旁';
  return (
    <Container>
      <Text variant="h2" align="center">尋找NINA及白熊與男孩</Text>
      <Text variant="h2" align="center">換領商場優惠券</Text>
      <Box mt="0.5rem" p="0 30px 0 12px">
        <Text shadow>恭喜閣下成功集齊3幅圖片，請於以下時間內出示此頁及H•COINS會員號碼換取<Text palette="tertiary">{location}HK$50購物及HK$50餐飲優惠券各乙張。</Text></Text>
        <Box>
          <Text shadow>(名額1500套，數量有限，先到先得，限額以親身換領時間計算。)</Text>
        </Box>
      </Box>
      <Flex flexDirection="column" justifyContent="flex-start" width={1} mt="auto" px="1.6rem">
        <Flex>
          <Text variant="body1" shadow>換領日期：</Text>
          <Text variant="body1" shadow>2020年11月23日至2021年1月3日</Text>
        </Flex>
        <Flex mt="0.4rem">
          <Text variant="body1" shadow>換領時間：</Text>
          <Text variant="body1" shadow>12:00nn - 8:00pm</Text>
        </Flex>
        <Flex mt="0.4rem">
          <Text variant="body1" shadow>換領地點：</Text>
          <Text variant="body1" shadow>{redeemAddress}</Text>
        </Flex>
      </Flex>
      <Flex mt="1rem" p="0 12px">
        <Text fontType="tertiary" variant="body2">* 注意：現時並沒有為閣下預留名額，限額以親身到達換領地點為準，為免向隅，請盡快到專櫃查詢餘額。</Text>
      </Flex>
      <Flex mt="1rem">
        <Button color="tertiary" to="/redeem">
          <Text palette="secondary" variant="h3">換領現金劵</Text>
        </Button>
      </Flex>
      <Flex justifyContent="flex-end" width={1} mt="0.5rem">
        <Text fontType="tertiary" variant="body2">*條款及細則適用</Text>
      </Flex>
    </Container>
  );
};

SuccessPage.propTypes = {
  appType: PropTypes.string,
};

SuccessPage.defaultProps = {
  appType: 'kolour_tw',
};

export default SuccessPage;
